/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import overviewAPI from 'src/api/overview';

export const getLeadsResults = createAsyncThunk('leadsResults/get', async arg => {
  return overviewAPI.getLeadsResults(arg);
});

const Slice = createSlice({
  name: 'leadResults',
  initialState: {
    isTabExpended: true,
    status: 'loading',
    legend: ['Total lead volume', 'Connected', 'Tagged'],
    message: '',
    data: [],
    arg: false,
  },
  reducers: {
    setTabExpend: (state, action) => {
      state.isTabExpended = action.payload;
    },
  },
  extraReducers: {
    [getLeadsResults.pending]: (state, action) => {
      state.status = 'loading';
      state.arg = action.meta.arg;
    },
    [getLeadsResults.fulfilled]: (state, action) => {
      const { status, message, data } = action.payload;
      state.status = status;
      state.message = message;
      state.data = data;
    },
    [getLeadsResults.rejected]: () => {},
  },
});

export const { setTabExpend } = Slice.actions;
export default Slice.reducer;
